/***
**Module Name: StripeStatusPill
 **File Name :  StripeStatusPill.jsx
 **Project :    SPOT SAVER
 **Copyright(c): SPOT SAVER.
 **Organization: SPOT SAVER
 **author :     Hari
 **license :
 **version :    1.0.0
 **Created on : Sep 04 2026
 **Last modified on:
 **Description: One client's Stripe payout readiness as a table-sized pill, for the
 **             Clients list. Words and colours come from stripeStatusMeta so this and
 **             the View Client panel always agree.
 ***/
import React from "react";
import { stripeStatusMeta, MUTED, BORDER } from "./stripeStatusMeta";

const StripeStatusPill = ({ stripe }) => {
    const meta = stripeStatusMeta(stripe);

    // No status reported at all (an API that predates this field). A dash says "not
    // known" without asserting the venue is disconnected.
    if (!meta) {
        return <span style={{ color: MUTED }} title="Stripe status is not available">—</span>;
    }

    // The reason lives in the tooltip rather than the cell: it is a sentence, the column
    // is 150px wide, and an admin only needs it once they have spotted the amber row.
    const reason = stripe.disabledReason
        ? `Stripe is holding payouts: ${stripe.disabledReason}`
        : meta.blurb;

    return (
        <span
            className="d-inline-flex align-items-center px-2 py-1 rounded-pill"
            title={reason}
            style={{
                fontSize: 11,
                fontWeight: 700,
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                color: meta.color,
                background: meta.tint,
                border: `1px solid ${meta.line || BORDER}`
            }}
        >
            {meta.label}
        </span>
    );
};

export default StripeStatusPill;
